<template>
  <div v-html="timer" class="timer"></div>
</template>

<script>
import moment from 'moment-timezone'

moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'Timer',
  props: ['targetTime'],
  data: function () {
    return {
      target: moment(),
      timer: ''
    }
  },
  mounted: function () {
    setInterval(() => {
      let countDown = moment(this.targetTime * 1000).utc() - moment().utc()
      let d = moment.duration(countDown / 1000, 'seconds')
      if (d.toString() === 'Invalid date') {
        this.timer = `投票締切まで--分--秒`
      } else if (countDown < 0) {
        this.timer = '<span class="warn">投票時間が過ぎています<br>次の投票開始をお待ちください</span>'
      } else {
        this.timer = `投票締切まで${d.minutes()}分${d.seconds()}秒`
      }
    }, 1000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.timer >>> span{
  color: #F44100;
  font-weight: bold;
}
@media all and (max-width: 740px) {
  .timer{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Timer.vue